module.exports = __webpack_public_path__ + "img/wz-8-1-1.6947666e.jpg";